(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-header"]) return;
  try {
    
  document.addEventListener(
    'shopify:block:select',
    event => {
      if ($('.pageheadervideo iframe').length) {
        pageheadervideo__innit();
      }
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-alta"]) return;
  try {
     document.addEventListener('shopify:block:select',
event => { $('.gallery').colcade('destroy'); $('.gallery').colcade({ columns:
'.grid-col', items: '.grid-item' }) }, true); 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-amaya"]) return;
  try {
    
  document.addEventListener(
    'shopify:block:select',
    event => {
      $('.gallery').colcade('destroy');
      $('.gallery').colcade({ columns: '.grid-col', items: '.grid-item' });
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-amela"]) return;
  try {
    

  document.addEventListener('shopify:block:select', event => {
    $('.gallery').colcade('destroy');
    $('.gallery').colcade({
      columns: '.grid-col',
      items: '.grid-item'
    })
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-aurea"]) return;
  try {
     document.addEventListener('shopify:block:select',
event => { $('.gallery').colcade('destroy'); $('.gallery').colcade({ columns:
'.grid-col', items: '.grid-item' }) }, true); 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-autumn-winter-2021"]) return;
  try {
    

  document.addEventListener('shopify:block:select', event => {
    $('.gallery').colcade('destroy');
    $('.gallery').colcade({
      columns: '.grid-col',
      items: '.grid-item'
    })
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-autumn-winter"]) return;
  try {
    

  document.addEventListener('shopify:block:select', event => {
    $('.gallery').colcade('destroy');
    $('.gallery').colcade({
      columns: '.grid-col',
      items: '.grid-item'
    })
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-aw-botanica-2021"]) return;
  try {
    

  document.addEventListener('shopify:block:select', event => {
    $('.gallery').colcade('destroy');
    $('.gallery').colcade({
      columns: '.grid-col',
      items: '.grid-item'
    })
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-aw-merida-2021"]) return;
  try {
    

  document.addEventListener('shopify:block:select', event => {
    $('.gallery').colcade('destroy');
    $('.gallery').colcade({
      columns: '.grid-col',
      items: '.grid-item'
    })
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-circadian"]) return;
  try {
     document.addEventListener('shopify:block:select',
event => { $('.gallery').colcade('destroy'); $('.gallery').colcade({ columns:
'.grid-col', items: '.grid-item' }) }, true); 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-cubism"]) return;
  try {
    
  document.addEventListener(
    'shopify:block:select',
    event => {
      $('.gallery').colcade('destroy');
      $('.gallery').colcade({ columns: '.grid-col', items: '.grid-item' });
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-cymatic-2022"]) return;
  try {
     document.addEventListener('shopify:block:select',
event => { $('.gallery').colcade('destroy'); $('.gallery').colcade({ columns:
'.grid-col', items: '.grid-item' }) }, true); 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-dala"]) return;
  try {
    

  document.addEventListener('shopify:block:select', event => {
    $('.gallery').colcade('destroy');
    $('.gallery').colcade({
      columns: '.grid-col',
      items: '.grid-item'
    })
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-kleio-2022"]) return;
  try {
     document.addEventListener('shopify:block:select',
event => { $('.gallery').colcade('destroy'); $('.gallery').colcade({ columns:
'.grid-col', items: '.grid-item' }) }, true); 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-kora-2022"]) return;
  try {
     document.addEventListener('shopify:block:select',
event => { $('.gallery').colcade('destroy'); $('.gallery').colcade({ columns:
'.grid-col', items: '.grid-item' }) }, true); 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-limited"]) return;
  try {
    

  document.addEventListener('shopify:block:select', event => {
    $('.gallery').colcade('destroy');
    $('.gallery').colcade({
      columns: '.grid-col',
      items: '.grid-item'
    })
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-mari"]) return;
  try {
    
  document.addEventListener(
    'shopify:block:select',
    event => {
      $('.gallery').colcade('destroy');
      $('.gallery').colcade({ columns: '.grid-col', items: '.grid-item' });
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-melusina"]) return;
  try {
     document.addEventListener('shopify:block:select',
event => { $('.gallery').colcade('destroy'); $('.gallery').colcade({ columns:
'.grid-col', items: '.grid-item' }) }, true); 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-nara"]) return;
  try {
    

  document.addEventListener('shopify:block:select', event => {
    $('.gallery').colcade('destroy');
    $('.gallery').colcade({
      columns: '.grid-col',
      items: '.grid-item'
    })
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-onda-2022"]) return;
  try {
     document.addEventListener('shopify:block:select',
event => { $('.gallery').colcade('destroy'); $('.gallery').colcade({ columns:
'.grid-col', items: '.grid-item' }) }, true); 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-retta"]) return;
  try {
    
  document.addEventListener(
    'shopify:block:select',
    event => {
      $('.gallery').colcade('destroy');
      $('.gallery').colcade({ columns: '.grid-col', items: '.grid-item' });
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-selene"]) return;
  try {
     document.addEventListener('shopify:block:select',
event => { $('.gallery').colcade('destroy'); $('.gallery').colcade({ columns:
'.grid-col', items: '.grid-item' }) }, true); 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-signatures"]) return;
  try {
    
  document.addEventListener(
    'shopify:block:select',
    event => {
      $('.gallery').colcade('destroy');
      $('.gallery').colcade({ columns: '.grid-col', items: '.grid-item' });
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-siren"]) return;
  try {
     document.addEventListener('shopify:block:select',
event => { $('.gallery').colcade('destroy'); $('.gallery').colcade({ columns:
'.grid-col', items: '.grid-item' }) }, true); 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-spring-summer"]) return;
  try {
    

  document.addEventListener('shopify:block:select', event => {
    $('.gallery').colcade('destroy');
    $('.gallery').colcade({
      columns: '.grid-col',
      items: '.grid-item'
    })
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-ss-21-kea"]) return;
  try {
    

  document.addEventListener('shopify:block:select', event => {
    $('.gallery').colcade('destroy');
    $('.gallery').colcade({
      columns: '.grid-col',
      items: '.grid-item'
    })
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-ss-21-rey"]) return;
  try {
    

  document.addEventListener('shopify:block:select', event => {
    $('.gallery').colcade('destroy');
    $('.gallery').colcade({
      columns: '.grid-col',
      items: '.grid-item'
    })
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-ss-21-rey2"]) return;
  try {
    

  document.addEventListener('shopify:block:select', event => {
    $('.gallery').colcade('destroy');
    $('.gallery').colcade({
      columns: '.grid-col',
      items: '.grid-item'
    })
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-ss-21-ula"]) return;
  try {
     document.addEventListener('shopify:block:select',
event => { $('.gallery').colcade('destroy'); $('.gallery').colcade({ columns:
'.grid-col', items: '.grid-item' }) }, true); 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-syra"]) return;
  try {
    
  document.addEventListener(
    'shopify:block:select',
    event => {
      $('.gallery').colcade('destroy');
      $('.gallery').colcade({ columns: '.grid-col', items: '.grid-item' });
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-theia"]) return;
  try {
     document.addEventListener('shopify:block:select',
event => { $('.gallery').colcade('destroy'); $('.gallery').colcade({ columns:
'.grid-col', items: '.grid-item' }) }, true); 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-tierra"]) return;
  try {
    
  document.addEventListener(
    'shopify:block:select',
    event => {
      $('.gallery').colcade('destroy');
      $('.gallery').colcade({ columns: '.grid-col', items: '.grid-item' });
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-vero"]) return;
  try {
    
  document.addEventListener(
    'shopify:block:select',
    event => {
      $('.gallery').colcade('destroy');
      $('.gallery').colcade({ columns: '.grid-col', items: '.grid-item' });
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-moodboard-vita-2022"]) return;
  try {
     document.addEventListener('shopify:block:select',
event => { $('.gallery').colcade('destroy'); $('.gallery').colcade({ columns:
'.grid-col', items: '.grid-item' }) }, true); 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-spring-summer"]) return;
  try {
    

  document.addEventListener('shopify:block:select', event => {
    <!-- homeslides__resize(); -->
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-ss-21-kea"]) return;
  try {
    

  document.addEventListener('shopify:block:select', event => {
    <!-- homeslides__resize(); -->
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-ss-21-rey"]) return;
  try {
    

  document.addEventListener('shopify:block:select', event => {
    <!-- homeslides__resize(); -->
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["color-swatches-generichandle"]) return;
  try {
    
  $('.colorswatch__trigger').on('click', function() {
    $('.colorswatch').toggleClass('open');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["color-swatches"]) return;
  try {
    
  $(document).on('click', '.colorswatch__trigger', function () {
    $(this).parents('.colorswatch').toggleClass('open');
  });

  $(document).mouseup(e => {
    const $trigger = $('.colorswatch__trigger');
    const $coloroptions = $('.colorswatch__options');
    if (
      !$trigger.is(e.target) &&
      $trigger.has(e.target).length === 0 &&
      !$coloroptions.is(e.target) &&
      $coloroptions.has(e.target).length === 0
    ) {
      $('.colorswatch').removeClass('open');
    }
  });

  setTimeout(function () {
    const buttons_var = document.querySelectorAll('.product__optionlist li');

    for (const button_var of buttons_var) {
      button_var.addEventListener('click', function (event) {
        if (window.esc_now_back_in_stock) {
          window.esc_now_back_in_stock.triggerRefresh();
        }
      });
    }
  }, 1000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-columns"]) return;
  try {
    

  document.addEventListener('shopify:block:select', event => {
    effectsInit();
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-fields-about"]) return;
  try {
    

const customFieldsInit = function(){

  effectsInit();

  // Re-init lazy load
  lazyLoadInstance.update(); // reinit lazy load after clones
};
customFieldsInit();

document.addEventListener('shopify:block:deselect', event => {
  customFieldsInit();
}, true);
document.addEventListener('shopify:section:load', event => {
  customFieldsInit();
}, true);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-fields-gift-cards"]) return;
  try {
    

const customFieldsInit = function(){

  effectsInit();

  // Re-init lazy load
  lazyLoadInstance.update(); // reinit lazy load after clones
};
customFieldsInit();

document.addEventListener('shopify:block:deselect', event => {
  customFieldsInit();
}, true);
document.addEventListener('shopify:section:load', event => {
  customFieldsInit();
}, true);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-fields-klarna"]) return;
  try {
    

const customFieldsInit = function(){

  effectsInit();

  // Re-init lazy load
  lazyLoadInstance.update(); // reinit lazy load after clones
};
customFieldsInit();

document.addEventListener('shopify:block:deselect', event => {
  customFieldsInit();
}, true);
document.addEventListener('shopify:section:load', event => {
  customFieldsInit();
}, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-fields-showroom"]) return;
  try {
    

  const customFieldsInit = function(){
    effectsInit();
  };
  customFieldsInit();

  document.addEventListener('shopify:block:deselect', event => {
    customFieldsInit();
  }, true);
  document.addEventListener('shopify:section:load', event => {
    customFieldsInit();
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-fields-size-guide"]) return;
  try {
    

  document.addEventListener('shopify:section:load', event =>{
    init_functions();
  }, true);
  document.addEventListener('shopify:block:deselect', event => {
    init_functions();
  }, true);

  function init_functions(){
    effectsInit();

    if($(".tabsection__header").length > 0 ){
      tabsections__init();
    }

    if($(".sizetable__content").length > 0){
      formatSizeTables();
    }

    if($(".stylecarousel__carousel").length > 0){
      stylecarousel__init();
    }
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-fields-sizeguide"]) return;
  try {
    
  const customFieldsInit = function () {
    effectsInit();

    if ($('.sizetable__content').length > 0) {
      formatSizeTables();
    }

    // Re-init lazy load
    lazyLoadInstance.update(); // reinit lazy load after clones
  };
  customFieldsInit();

  document.addEventListener(
    'shopify:block:deselect',
    event => {
      customFieldsInit();
    },
    true
  );
  document.addEventListener(
    'shopify:section:load',
    event => {
      customFieldsInit();
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-fields-stores"]) return;
  try {
    

const customFieldsInit = function(){

  effectsInit();

  // Re-init lazy load
  lazyLoadInstance.update(); // reinit lazy load after clones
};
customFieldsInit();

document.addEventListener('shopify:block:deselect', event => {
  customFieldsInit();
}, true);
document.addEventListener('shopify:section:load', event => {
  customFieldsInit();
}, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-fields-sustainability"]) return;
  try {
    
  const customFieldsInit = function () {
    effectsInit();

    // Re-init lazy load
    lazyLoadInstance.update(); // reinit lazy load after clones
  };
  customFieldsInit();

  document.addEventListener(
    'shopify:block:deselect',
    event => {
      customFieldsInit();
    },
    true
  );

  document.addEventListener(
    'shopify:section:load',
    event => {
      customFieldsInit();
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-fields"]) return;
  try {
    

const customFieldsInit = function(){

  effectsInit();

  // Re-init lazy load
  lazyLoadInstance.update(); // reinit lazy load after clones
};
customFieldsInit();

document.addEventListener('shopify:block:deselect', event => {
  customFieldsInit();
}, true);
document.addEventListener('shopify:section:load', event => {
  customFieldsInit();
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-collections"] && !Shopify.designMode) return;
  try {
    
  const featureCollectionInit = function () {
    const shopifySections = document.querySelectorAll('.shopify-section');
    sectionBackgroundInit(shopifySections);

    effectsInit();

    // Re-init lazy load
    lazyLoadInstance.update(); // reinit lazy load after clones
  };
  featureCollectionInit();

  document.addEventListener(
    'shopify:block:deselect',
    event => {
      featureCollectionInit();
      console.log('deselect');
    },
    true
  );

  document.addEventListener(
    'shopify:section:unload',
    event => {
      // productCarouselInit(); -->
      console.log('unload');
    },
    true
  );
  document.addEventListener(
    'shopify:section:load',
    event => {
      featureCollectionInit();
      console.log('load');
    },
    true
  );
  document.addEventListener(
    'shopify:section:reorder',
    event => {
      console.log('reorder');
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-media"] && !Shopify.designMode) return;
  try {
    

  const featureMediaInit = function(){

    const shopifySections = document.querySelectorAll(".shopify-section");
    sectionBackgroundInit(shopifySections);

    featureMediaInit();

    effectsInit();

    // Re-init lazy load
    lazyLoadInstance.update(); // reinit lazy load after clones
  };

  document.addEventListener('shopify:block:deselect', event => {
    featureMediaInit();
  }, true);

  document.addEventListener('shopify:section:load', event => {
    featureMediaInit();
    console.log('load');
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"]) return;
  try {
    
  document.addEventListener(
    'shopify:section:load',
    event => {
      init_functions();
    },
    true
  );
  document.addEventListener(
    'shopify:block:deselect',
    event => {
      init_functions();
    },
    true
  );

  function init_functions() {
    console.log('initialising');
    if ($('.herovideo__iframe').length > 0) {
      // Homepage hero video is not playing yet, so continue to check before running transition
      herovideo__innit();
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-asktobuy"]) return;
  try {
    

const asktobuyInit = function () {
  const asktobuyPopup = document.querySelector('.asktobuy__popup');
  const asktobuyBtn = document.querySelector('.product__asktobuy');

  if (!asktobuyPopup) {
    asktobuyBtn.style.display = 'none';
    return;
  }

  const asktobuyBtnClose = document.querySelector('.asktobuy__popup_close');

  asktobuyBtn.addEventListener('click', function(){
    console.log('click');
    asktobuyPopup.classList.add('open');
  });
  asktobuyBtnClose.addEventListener('click', function(){
      console.log('close');
    asktobuyPopup.classList.remove('open');
  });

};
asktobuyInit();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    

const productCarouselInit = function(){

  const shopifySections = document.querySelectorAll(".shopify-section");
  sectionBackgroundInit(shopifySections);

  gridCarouselInit();

  const effects = document.querySelectorAll(".effect");
  effects.forEach((item, i) => {
    item.classList.add("effect--ready");
  });

  // Re-init lazy load
  lazyLoadInstance.update(); // reinit lazy load after clones
};
productCarouselInit();

  document.addEventListener('shopify:block:deselect', event => {
    productCarouselInit();
    console.log('deselect');
  }, true);

  document.addEventListener('shopify:section:unload', event => {
    <!-- productCarouselInit(); -->
    console.log('unload');
  }, true);
  document.addEventListener('shopify:section:load', event => {
    productCarouselInit();
    console.log('load');
  }, true);
  document.addEventListener('shopify:section:reorder', event => {
    console.log('reorder');
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-collage-with-content"] && !Shopify.designMode) return;
  try {
    

const productCollageInit = function(){

  const shopifySections = document.querySelectorAll(".shopify-section");
  sectionBackgroundInit(shopifySections);

  effectsInit();

  // Re-init lazy load
  lazyLoadInstance.update(); // reinit lazy load after clones
};
productCollageInit();

  document.addEventListener('shopify:block:deselect', event => {
    productCollageInit();
    console.log('deselect');
  }, true);
  document.addEventListener('shopify:section:load', event => {
    productCollageInit();
    console.log('load');
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-fullwidth-image"]) return;
  try {
    

const productFullWidthInit = function(){

  const effects = document.querySelectorAll(".effect");
  effectsInit(effects);

  // Re-init lazy load
  lazyLoadInstance.update(); // reinit lazy load after clones
};
productFullWidthInit();

  document.addEventListener('shopify:block:deselect', event => {
    productFullWidthInit();
  }, true);
  document.addEventListener('shopify:section:load', event => {
    productFullWidthInit();
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-giftcard"]) return;
  try {
    

  const $trigger = $('.colorswatch__trigger');

  $trigger.on('click', function() {
    $('.colorswatch').toggleClass('open');
    addEventListener('click', function(){

    });
  });

  $(document).mouseup(e => {
   if (!$trigger.is(e.target) && $trigger.has(e.target).length === 0){
     $('.colorswatch').removeClass('open');
   }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    

  var loadProductRecommendationsIntoSection = function() {

    var productRecommendationsSection = document.querySelector(".product-recommendations");
    var productId = productRecommendationsSection.dataset.productId;
    var baseUrl = productRecommendationsSection.dataset.baseUrl;
    var limit = productRecommendationsSection.dataset.limit;
    var requestUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=" + limit;

    $.ajax({ type: "GET",
     url: requestUrl,
     success : function(data)
     {
         productRecommendationsSection.parentElement.innerHTML = data;

		jQuery(document).ready(function(){

            $('.product-recommendations .relatedproducts__carousel').slick({
              slidesToShow: 4,
              slidesToScroll: 4,
              arrows: false,
              infinite: false,
              responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToScroll: 4,
                    slidesToShow: 4,
                  }
                },
                {
                  breakpoint: 1000,
                  settings: {
                    slidesToScroll: 3,
                    slidesToShow: 3,
                  }
                },
                {
                  breakpoint: 700,
                  settings: {
                    slidesToScroll: 2,
                    slidesToShow: 2,
                  }
                }
              ]
            });



           $('.product-recommendations .relatedproducts__navitem--next').click(function(){
              var parent = $(this).closest('.relatedproducts');
              parent.find('.relatedproducts__carousel').slick('slickNext');
            });

            $('.product-recommendations .relatedproducts__navitem--prev').click(function(){
              var parent = $(this).closest('.relatedproducts');
              parent.find('.relatedproducts__carousel').slick('slickPrev');
            });
		});
     }
    });


  };

    // Listen for changes done in the Theme Editor
    document.addEventListener("shopify:section:load", function(event) {
      if (event.detail.sectionId === "product-recommendations") {
        loadProductRecommendationsIntoSection();
      }
    });
    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["showroom-gallery"]) return;
  try {
    

  const showroomGalleryInit = function(){

    effectsInit();

    // Re-init lazy load
    lazyLoadInstance.update(); // reinit lazy load after clones

    imagesCarouselInit();
  };

  document.addEventListener('shopify:block:deselect', event => {
    showroomGalleryInit();
  }, true);

  document.addEventListener('shopify:section:load', event => {
    showroomGalleryInit();
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide-furtherhelp"]) return;
  try {
    
    document.addEventListener('shopify:section:load', event =>{
      effects__init();
    }, true);
    document.addEventListener('shopify:block:select', event => {
      effects__init();
    }, true);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide-howtomeasure"]) return;
  try {
    
  document.addEventListener('shopify:section:load', event =>{
    effects__init();
  }, true);
  document.addEventListener('shopify:block:select', event => {
    effects__init();
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sizeguide-bodywear"]) return;
  try {
    
  const sizeguideInit = function () {
    if ($('.sizetable__content').length > 0) {
      formatSizeTables();
    }
  };

  document.addEventListener(
    'shopify:section:load',
    event => {
      sizeguideInit();
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sizeguide-bottoms"]) return;
  try {
    
  const sizeguideInit = function () {
    if ($('.sizetable__content').length > 0) {
      formatSizeTables();
    }
  };

  document.addEventListener(
    'shopify:section:load',
    event => {
      sizeguideInit();
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sizeguide-bras"]) return;
  try {
    
  const sizeguideInit = function () {
    if ($('.sizetable__content').length > 0) {
      formatSizeTables();
    }
  };

  document.addEventListener(
    'shopify:section:load',
    event => {
      sizeguideInit();
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sizeguide-howto"]) return;
  try {
    
  document.addEventListener('shopify:section:select', event => {
   effects__init();
  }, true);

  document.addEventListener('shopify:section:deselect', event => {
   effects__init();
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-2-images"] && !Shopify.designMode) return;
  try {
    
  const textTwoImagesInit = function () {
    const shopifySections = document.querySelectorAll('.shopify-section');
    sectionBackgroundInit(shopifySections);

    effectsInit();

    // Re-init lazy load
    lazyLoadInstance.update(); // reinit lazy load after clones
  };
  textTwoImagesInit();

  document.addEventListener(
    'shopify:block:deselect',
    event => {
      textTwoImagesInit();
      console.log('deselect');
    },
    true
  );
  document.addEventListener(
    'shopify:section:load',
    event => {
      textTwoImagesInit();
      console.log('load');
    },
    true
  );

  } catch(e) { console.error(e); }
})();
})();
